import Head from 'next/head'

export default function BreadcrumbSeriesJsonLd ({ series }) {
  const category = (series.categories && series.categories.length > 0) ? series.categories[0] : null

  if (!category) return ''

  const jsonld = `{
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "item": {
            "@id": "${process.env.NEXT_PUBLIC_JSON_LD_ORGANISARTION_URL}/rubriken/${category.slug}",
            "name": "${category.name}"
          }
        }
    ]
  }`

  return (
    <Head>
      <script
        type='application/ld+json'
        dangerouslySetInnerHTML={{ __html: jsonld }}
        key='jsonld-breadcrumb-series'
      />
    </Head>
  )
}
